/**
 * Mocking client-server processing
*/

import api from "../api"
export default {
	async getTemplate(id) {
		if (isNaN(parseInt(id))) {
			throw Error("ID must be a number")
		}
		let value = await api.get(`/audit-templates/${id}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return {...data, checklist: JSON.parse(data.checklist)}
	},
	async getActiveTemplates(AllowFlowDown,AllowOnsite){
		let value = await api.get(`/audit-templates/active`, { params: { AllowFlowDown: AllowFlowDown, AllowOnsite: AllowOnsite } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data
		return {...data}
	},
	async getInactiveTemplates(AllowFlowDown,AllowOnsite){
		let value = await api.get(`/audit-templates/inactive`, { params: { AllowFlowDown: AllowFlowDown, AllowOnsite: AllowOnsite } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data
		return {...data}
	},
	/**
	 * 
	 * @param {number} id id of template
	 * @param {boolean} active should be active
	 */
	async updateActiveTemplates(id,active){
		let value = await api.put(`/audit-templates/active/${id}`,{active})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
	},
	/**
     * Returns id of new template
     * @param {string} name 
     * @param {object[]} questions 
     */
	async addTemplate(name, questions, fileID, checklist, AllowFlowDown, AllowOnsite) {
		let defaultQuestions = [
			{
				name: "Welcome to Orixe Audit! Please fill out the fields below.",
				type: "title",
				hint: "",
				isDependent: false,
				dependencyQuestionID: null,
				dependencyQuestionValue: null,
				visible: true,
				required: true
			},
			{
				name: "Question Name",
				type: "singleanswer",
				hint: "",
				isDependent: false,
				dependencyQuestionID: null,
				dependencyQuestionValue: null,
				visible: true,
				required: true
			},
		]
		questions = questions ?? defaultQuestions
		let value = await api.post(`/audit-templates/`, { name: name, questions: questions, fileID: fileID, checklist: checklist, AllowFlowDown:AllowFlowDown, AllowOnsite:AllowOnsite})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	/**
     * Returns boolean for success
     * @param {number} id 
     * @param {string} name 
     * @param {Object[]} questions 
     */
	async updateTemplate(id, name, questions, fileID, checklist) {
		if (isNaN(parseInt(id))) {
			throw Error("ID must be a number")
		}
		let value = await api.put(`/audit-templates/${id}`, { name: name, questions: questions, fileID: fileID, checklist: checklist })
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return !!value.data.data[0]
	},

	/**
     * Gets a list of templates
     */
	async list({offset, limit, approval},AllowFlowDown) {
		let value = await api.get(`/audit-templates/`, {params: {
			offset: isNaN(offset) ? 0 : offset,
			limit: isNaN(limit) ? undefined : limit,
			approval,
			AllowFlowDown:AllowFlowDown
		}})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return {
			items: data,
			total: value.data.metadata.pagination.totalRecords
		}
	},
	/**
     * Deletes a template
     * @param {number} id 
     */
	async deleteTemplate(id) {
		if (isNaN(parseInt(id))) {
			throw Error("ID must be a number")
		}
		let value = await api.delete(`/audit-templates/${id}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
	},
	/**
	 * 
	 * @param {number} id id of template
	 * @param {boolean} approval should be approved
	 */
	async approveTemplate(id,approval) {
		if (isNaN(parseInt(id))) {
			throw Error("ID must be a number")
		}
		let value = await api.put(`/audit-templates/${id}/approval`, {approval})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
	},
	/**
	 * 
	 * @param {number} id id of template
	 */
	async getApprovals(id) {
		if (isNaN(parseInt(id))) {
			throw Error("ID must be a number")
		}
		let value = await api.get(`/audit-templates/${id}/approval`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	/**
	 * @param {number} id id of template
	 */
	async getChangelog(id) {
		if (isNaN(parseInt(id))) {
			throw Error("ID must be a number")
		}
		let value = await api.get(`/audit-templates/${id}/changelog`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	/**
	 * Sets whether flowdown is allowed
	 * @param {boolean} flowdown The value to set
	 */
	async setFlowDown(id, flowdown) {
		let value = await api.put(`/audit-templates/${id}/flowdown`, {flowdown})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
	},

	async getOnsiteActiveTemplates(){
		let value = await api.get(`/onsite-audit-templates/active`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data
		return {...data}
	},

	async getOnsiteInactiveTemplates(){
		let value = await api.get(`/onsite-audit-templates/inactive`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data
		return {...data}
	},
	
	async onsiteList({offset, limit, approval}) {
		let value = await api.get(`/onsite-audit-templates/`, {params: {
			offset: isNaN(offset) ? 0 : offset,
			limit: isNaN(limit) ? undefined : limit,
			approval
		}})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return {
			items: data,
			total: value.data.metadata.pagination.totalRecords
		}
	},

	async addTemplateRequest(id, templateApproval, auditorID, selectedAuditor, auditorType, invitationCode) {
		let value = await api.post(`/onsite-audit-template-request/`, {
			templateID: id,
			templateApproval: templateApproval,
			auditorID: auditorID,
			selectedAuditor: selectedAuditor,
			auditorType: auditorType,
			invitationCode: invitationCode
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},

	async getTemplateRequest() {
		let value = await api.get(`/onsite-audit-template-request/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},

	async updateTemplateComment(id, comment) {
		let value = await api.put(`/onsite-audit-template-request/`, { 
			templateID: id,
			comment: comment,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},

	async getTemplateComment(templateID) {
		let value = await api.get(`/onsite-audit-template-comment/`, { params: { templateID: templateID }})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},

	async templateCommentChecked(id, checked) {
		let value = await api.put(`/onsite-audit-template-comment/`, { 
			templateID: id,
			checked: checked,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},

	async onsiteTemplateApprove(id, approved) {
		let value = await api.put(`/onsite-audit-template-approve/`, { 
			templateID: id,
			approved: approved,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},

	async getOnsiteTemplateRequest(clientName) {
		let value = await api.get(`/onsite-pending-template-request/`, { params: { clientName: clientName }})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},
}